import api from "../../index";

export const getSalesOffices = (params) =>
  api.get("Sales/office/get-all", { params });

export const addUpdateSalesOffice = (body) =>
  api.post("Sales/office/add-update", body);

export const deleteSalesOffice = (officeId) =>
  api.delete(`Sales/office/delete?officeId=${officeId}`);
